export default __webpack_public_path__ + "static/media/background.94ea6124.png";